<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<app-alert></app-alert>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation.default" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center  p-6 pl-0 pt-2">
            <!-- Light version -->
            <img src="assets/images/logo/side-bar-logo.png" alt="Logo image">
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="fixed flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>


        <!-- <mat-form-field>
            <mat-label>Select an option</mat-label>
            <mat-select [(value)]="selectedOption">
              <mat-option *ngFor="let option of options" [value]="option.value">
                {{ option.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
        <div *ngIf="isAdmin" style="border-radius: 8px !important;border: 1px solid #383F51 !important;    height: 56% !important;
          padding-left: 14px !important;
          padding-right: 14px !important;
          padding-top: 8px !important;" [ngClass]=" shiftDataService.isSLA ? 'opacity-0' : 'opacity-1'">
            <p *ngIf="shiftDataService.sitesCount === 1" style="color: #383F51;
            font-family: 'Inter var';
            font-size: 14px;
            font-style: normal;text-align: center !important;
            font-weight: 500;
            line-height: normal;">{{dashboardService.translate(orgName)}}{{' | '}}{{dashboardService.translate(siteName)}}</p>

            
<p *ngIf="shiftDataService.sitesCount > 1" style="
    position: relative;color: #383F51;
font-family: 'Inter var';
font-size: 14px;    left: 9px !important;
font-style: normal;text-align: center !important;
font-weight: 500;
    bottom: 16px !important;
line-height: normal;">{{orgName}}{{' | '}}{{shiftDataService.selectedSite.length}} Sites Selected
        <button *ngIf="shiftDataService.sitesCount > 1" mat-icon-button  [matMenuTriggerFor]="SiteDetails" [matTooltip]="''" (click)="openMatmenu()"
            style="top: 6px !important;" [disabled]="shiftDataService.isSLA ? true : false">
            <mat-icon class="relative " style="height: 20px !important;width: 20px !important;" 
                [svgIcon]="'custom_solid:downward-arrow-icon'">
            </mat-icon>
        </button>     </p>
           
            <!-- Button -->
   </div>

        <!-- Language menu -->
        <div>
        <mat-menu [xPosition]="'before'" #SiteDetails="matMenu" (click)="$event.stopPropagation()" (closed)="onMenuClosed()" style="    padding-left: 28px !important;width: 75% !important;">
        <p class="text-style-dropdown" style="left: 9px !important;position: relative;">All Sites</p> 
        <mat-slide-toggle class="pl-1 pr-1 mat-slide-toggle-bar-style mat-slide-toggle-checked-style" 
        [checked]="allSitesSelected" style="bottom: 37px !important; position: relative;left: 173px !important; "  
            (click)="$event.stopPropagation()" (change)="siteSelectionChanged($event)"></mat-slide-toggle>   
            <hr style="width: 83% !important;
            left: 22px !important;
            position: relative;
            bottom: 18px !important;">
            <p style="color: #99A8CB;
            font-family: 'Inter var';
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
    bottom: 5px !important;
    position: relative;
    padding-left: 27px !important;">Select Sites</p>
         <div class="checkbox-wrapper">
            <mat-checkbox class=""  (click)="$event.stopPropagation()" [checked]="isChecked(siteDetails.site_name)" (change)="changeSite(siteDetails.site_name,SiteDetails)"
             *ngFor="let siteDetails of masterSites"> 
                <button mat-menu-item class="text-style-dropdown" style="color: #383F51 !important;padding-left: 8px !important;" 
                (click)="changeSite(siteDetails.site_name,SiteDetails)" >
                    {{siteDetails.site_name}} </button>
            </mat-checkbox>  
        </div>
        </mat-menu>
        </div>
        <span *ngIf="!isAdmin" class="inline-flex align-middle">{{dashboardService.translate(siteName)}}{{' | '}}{{dashboardService.translate(orgName)}}</span>
        <!-- Components -->
        <div class="fixed  right-1 flex items-center pl-2 space-x-0.5 sm:space-x-2" [ngClass]=" jhnsw ? 'top-[0.5vh]' : 'top-[1.2vh]' ">
            <button *ngIf="isRoadis" class="relative pointer font-semibold " [matTooltip]="panelTooltip" style="color:#D39B11;
            font-family: 'Inter var';
            font-size: 15px !important;
            font-style: normal !important;cursor: pointer;" (click)="openRequestedPanel()">Open {{panelName}}
            <mat-icon class="relative " style="width: 16px !important;
            cursor: pointer;
            right: 3px !important;
            height: 18px !important;
            top: 3px !important;
            min-height: 3px !important;
            max-height: 27px !important;"
                [svgIcon]="'custom_solid:tab-icon'" ></mat-icon>
            </button> 
            <!-- <downloads *ngIf="!isAdmin"></downloads> -->
            <languages *ngIf="!isAdmin"></languages>
            <fuse-fullscreen  *ngIf="!isAdmin" class="hidden md:block"></fuse-fullscreen>
            <!--search [appearance]="'bar'"></search--> 
            <!-- //configuration files -->
            <img [ngClass]="logoDimension" [src]="logoImagePlaceHolder">

            <!--            <shortcuts></shortcuts>-->
            <!--            <messages></messages>-->
            <!-- <notifications></notifications> -->
            <!--            <button-->
            <!--                class="lg:hidden"-->
            <!--                mat-icon-button-->
            <!--                (click)="quickChat.toggle()">-->
            <!--                <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>-->
            <!--            </button>-->
            <!-- <user></user> -->
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto py-4 px-4">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!-- <div
        class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div> -->

</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->